module.exports = __webpack_public_path__ + "img/monitoring-truck-track.1e58b51b.svg";